/*
 * silkify-slider-dots.js
 *
 * Añade paginación por puntos a los carruseles de Dawn (<slider-component>).
 * Dawn solo pinta puntos en <slideshow-component>; el resto de secciones usan
 * flechas + contador "1 / 5". Este script reutiliza las clases y los estilos
 * que YA existen en assets/component-slider.css
 * (.slider-counter--dots / .slider-counter__link--dots / .dot) para no duplicar CSS.
 *
 * Se activa en cualquier <slider-component> que contenga un .slider-counter--dots.
 * No depende de SliderComponent: lee la posición directamente del scroll, así que
 * sigue funcionando aunque las flechas estén ocultas o no se rendericen.
 */
(function () {
  'use strict';

  var BOUND_FLAG = 'silkifyDotsBound';

  function getSlides(sliderComponent) {
    return Array.prototype.slice.call(sliderComponent.querySelectorAll('[id^="Slide-"]'));
  }

  function visibleSlides(slides) {
    return slides.filter(function (slide) {
      return slide.clientWidth > 0;
    });
  }

  function slideOffset(slides) {
    if (slides.length < 2) return 0;
    return slides[1].offsetLeft - slides[0].offsetLeft;
  }

  function init(sliderComponent) {
    if (sliderComponent[BOUND_FLAG]) return;

    var wrapper = sliderComponent.querySelector('.slider-counter--dots');
    var slider = sliderComponent.querySelector('[id^="Slider-"]');
    if (!wrapper || !slider) return;

    var dots = Array.prototype.slice.call(wrapper.querySelectorAll('.slider-counter__link--dots'));
    if (!dots.length) return;

    sliderComponent[BOUND_FLAG] = true;

    var ticking = false;

    function setActive(index) {
      dots.forEach(function (dot, i) {
        var isActive = i === index;
        dot.classList.toggle('slider-counter__link--active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function currentIndex() {
      var slides = visibleSlides(getSlides(sliderComponent));
      var offset = slideOffset(slides);
      if (!offset) return 0;
      var index = Math.round(slider.scrollLeft / offset);
      return Math.max(0, Math.min(slides.length - 1, index));
    }

    function sync() {
      ticking = false;
      setActive(currentIndex());
    }

    slider.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(sync);
      },
      { passive: true }
    );

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function (event) {
        event.preventDefault();
        var slides = visibleSlides(getSlides(sliderComponent));
        var target = slides[index];
        if (!target) return;
        slider.scrollTo({
          left: target.offsetLeft - slides[0].offsetLeft,
          behavior: 'smooth',
        });
      });
    });

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(sync).observe(slider);
    } else {
      window.addEventListener('resize', sync);
    }

    sync();
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('slider-component').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Editor de temas: al recargar una sección hay que volver a enganchar los puntos.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
